var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 46,
    viewBox: "0 0 152 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 31.1474C1 31.1474 6.91288 30.079 13.6355 32.6457C26.4215 37.5275 27.1509 28.5877 31.892 24.2772C36.2297 20.3334 39.8221 22.7397 44.6517 27.5625C48.2138 31.1196 53.4051 37.0905 58.7812 36.1292C63.6956 35.2506 67.1794 28.2475 73.9912 26.4665C79.39 25.055 83.7775 28.9329 89.9942 27.5625C98.4277 25.7035 102.195 14.7593 108.222 14.7593C115.661 14.7593 120.899 5.50311 127.667 5.50311C134.394 5.50311 135.307 10.946 142.667 14.7593C148.293 17.6746 151 14.7593 151 14.7593V45.9991H1V31.1474Z",
    fill: "url(#paint0_linear_2_3579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.2951C1 26.2951 6.91288 25.2422 13.6355 27.7718C26.4215 32.5829 27.1509 23.7725 31.892 19.5243C36.2297 15.6377 39.8221 18.0091 44.6517 22.7621C48.2138 26.2677 53.4051 32.1522 58.7812 31.2049C63.6956 30.3389 67.1794 23.4372 73.9912 21.682C79.39 20.2909 83.7775 24.1126 89.9942 22.7621C98.4277 20.93 102.195 10.1443 108.222 10.1443C115.661 10.1443 120.899 1 127.667 1C134.394 1 134.752 6.38613 142.111 10.1443C147.737 13.0174 151 10.1443 151 10.1443",
    stroke: "#0E60B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_3579",
    x1: 28.1089,
    y1: 26.051,
    x2: 28.1089,
    y2: 45.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGraph);
export default __webpack_public_path__ + "static/media/BlueGraph.19223e08586ef4c8dad7c673b62bcebb.svg";
export { ForwardRef as ReactComponent };